import { getAgentCode, getUserDetails, getOrgCartInfo, removeUserDetails, setRandomCookie, delete_cookie, clearListCookies, removeCartDetails } from "./storage";
import { Mixpanel, getEventName } from "./mixpanel";
import { CartDetailsType, InvestmentDetailsType } from "views/cart/type";
import { ENDPOINTS } from 'constants/endpoints';
import { get, getDefaultHeaders, post } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import * as LoginActions from 'views/login/login.actions';
import resolveURLParams from "./url-params-resolver";
import { TAX_STATUS_OBJ } from "constants/common-constants";

const SERVICE_TEMPLATE_FILE_URL: string = process.env.REACT_APP_SERVICE_TEMPLATE_FILE_URL || '';
const USER_CART_COOKIE = process.env.REACT_APP_CART_COOKIE_NAME || '';

export const addAgentCode = (url: string) => {

    if (getAgentCode()) {
        const searchIndex = url.indexOf('?') + 1;
        if (searchIndex) {
            return url.substring(0, searchIndex) + `agentCode=${getAgentCode()}&` + url.substring(searchIndex)
        }
        else url += `?agentCode=${getAgentCode()}`;
    }
    return url;

}

export const isMintproApp = () => {
    return ((window as any).ReactNativeWebView || (window as any).mpIsApp === true);
}

export const redirectToMintPro = () => {

    if ((window as any).mpIsApp === true && (window as any).mpFeatures && (window as any).mpFeatures.close === true) {
        let reactPayload = {
            type: 'close'
        }
        window.postMessage(JSON.stringify(reactPayload), '*');
    }
    else if ((window as any).__REACT_WEB_VIEW_BRIDGE && typeof (window as any).__REACT_WEB_VIEW_BRIDGE.postMessage === 'function') {
        let reactPayload = {
            type: 'close',
            payload: {
                screenUrl: '/sell'
            }
        }
        return (window as any).__REACT_WEB_VIEW_BRIDGE.postMessage(JSON.stringify(reactPayload), "*");
    }


    else {
        const mintproUrl: string = process.env.REACT_APP_MINTPRO_URL ? process.env.REACT_APP_MINTPRO_URL : "";
        window.location.assign(mintproUrl);
    }
};

export const redirectToHome = (source?: string) => {
    Mixpanel.track(getEventName("goHome", "clicked", "header"), {
        agentCode: getAgentCode(),
        user: getUserDetails()
    });
    window.location.href = addAgentCode('/v1/home');
}

export const redirectToOld = (page: string, openInNew?: boolean) => {
    if (openInNew) window.open(`${window.location.origin}/${page}`, '_blank');
    else window.location.href = `${window.location.origin}/${page}`;
}

export const isProUser = () => {
    return (window.location.hostname.substring(0, 3) === "pro" || window.location.hostname.substring(0, 7) === "www.pro") && getAgentCode();
}

export const isBtoCFlow = () => {
    //returns false if pro is present in URL
    return (!(window.location.hostname.substring(0, 3) === "pro" || window.location.hostname.substring(0, 7) === "www.pro"))
}

export const downloadFileMintpro = (fileName: string, fileUrl: string, fileType: string) => {
    if ((window as any).mpFeatures && (window as any).mpFeatures.download === true) {
        var featurePayload = {
            type: 'download',
            payload: {
                fileName: fileName,
                fileUrl: fileUrl,
                fileType: fileType,
            },
        };
        window.postMessage(JSON.stringify(featurePayload), "*");
    }
}

export const getQueryParamsFromString = (search: string) => {
    let queryParams: any = {}
    if (search && search?.length) {
        if (search[0] === '?') search = search.substring(1);
        search.split('&').forEach((searchParamStr: string) => {
            let searchParam: string[] = searchParamStr.split('=');
            if (searchParam?.length === 2) {
                queryParams[searchParam[0]] = searchParam[1];
            }
            else if (searchParam?.length > 2) {
                queryParams[searchParam[0]] = searchParamStr.split(`${searchParam[0]}=`)[1];
            }
        });
    }
    return queryParams;
}

export const removeQueryParamFromString = (paramToRemove: string): string => {

    let allParams = getQueryParamsFromString(window.location.search);

    let returnString = window.location.pathname + "?";

    Object.keys(allParams).forEach((key) => {
        if (key !== paramToRemove) {
            returnString = returnString + `${key}=${allParams[key]}&`;
        }
    });

    return returnString;
}

export const getNonNullDefinedObject = (source: any) => {
    let target: any = {};
    for (let key in source) {
        if (source[key] !== null && source[key] !== undefined) {
            target[key] = source[key];
        }
    }
    return target;
}

export const getTotalCartInvestmentAmountFromCartDetails = (cartDetails: CartDetailsType): number => {
    if (cartDetails && cartDetails.activeInvestmentDetails) {
        return cartDetails.activeInvestmentDetails.reduce((sum: number, investmentDetail: InvestmentDetailsType) => sum + investmentDetail.amount, 0);
    }
    return 0;
}

export const getURLwithoutPro = (url: String) => {
    var hn = window.location.host;
    if (hn.substring(0, 3) === "pro") hn = hn.substring(4);
    else if (hn.substring(0, 7) === "www.pro") hn = hn.substring(8);
    return `${window.location.protocol}//${hn}${url}`;
}

export const getRegisteredWithBseStatus = () => {
    const userDetails = getUserDetails();
    if (userDetails && userDetails?.registeredWithBse) {
        return userDetails.registeredWithBse;
    }
    return null;
}

export const refreshOnHistoryTraversal = (additionalFunc: Function) => {
    window.addEventListener("pageshow", (event) => {
        let navigtionType: any = window.performance.getEntriesByType("navigation")[0];
        const historyTraversal = event.persisted || (typeof window.performance != "undefined" && navigtionType?.type === "back_forward");

        if (historyTraversal) {
            additionalFunc();
            window.location.reload();

        }
    });
}

export const getEncryptedUserId = () => {
    const userDetails: any = getUserDetails();
    if (userDetails) {
        return userDetails.encryptedUserId;
    }
    return null;
}
export const getPrimaryEmail = () => {
    const userDetails = getUserDetails();
    if (userDetails) {
        return userDetails.primaryEmail;
    }
    return null;
}
export const getPrimaryMobile = () => {
    const userDetails = getUserDetails();
    if (userDetails) {
        return userDetails.primaryMobile;
    }
    return null;
}
export const getName = () => {
    const userDetails = getUserDetails();
    if (userDetails) {
        return userDetails.name;
    }
    return null;
}
export const getCartId = () => {
    const orgCartInfo = getOrgCartInfo();
    if (orgCartInfo && orgCartInfo.cartId) {
        return orgCartInfo.cartId;
    }
    return null;
}

export const investmentFrequencyFilter = (input: any) => {
    var inputText = '';
    if (input === undefined || input === null || input === '') {
        inputText = '';
    } else {
        if (input === 1) {
            inputText = 'Monthly';
        } else if (input === 3) {
            inputText = 'Quarterly';
        } else if (input === 6) {
            inputText = 'Half-Yearly';
        } else if (input === 12) {
            inputText = 'Yearly';
        }
    }
    return inputText;
};
export const addRankSuffix = (num: number) => {
    if ([11, 12, 13].indexOf(num % 100) !== -1) {
        return num + "th";
    }
    switch (num % 10) {
        case 1:
            return num + "st";

        case 2:
            return num + "nd";

        case 3:
            return num + "rd";

        default:
            return num + "th";

    }
};

export const clearUserCookies = () => {
    removeUserDetails();
    LoginActions.fetchGetCurrentUserSuccess(null);
    removeCartDetails();
    delete_cookie('cookieId', true);
    setRandomCookie();
    sessionStorage.removeItem('x-auth-token');
    sessionStorage.removeItem('isUserFromCustomerListingPage');
    sessionStorage.removeItem('kycDetailsCoookie');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('primaryMobile');
    sessionStorage.removeItem('primaryEmail');
    sessionStorage.removeItem('cartId');
    sessionStorage.removeItem('userInfo');
    sessionStorage.removeItem('angular-cache.caches.defaultCache.data./prosperx-api/api/v1/portfolio/get-user-portfolio');
    sessionStorage.removeItem('angular-cache.caches.defaultCache.keys');
}
export const clearAllCookies = () => {
    clearUserCookies();
    clearListCookies(); 
    sessionStorage.removeItem('agentCodeCookie');
}

export const logOutUser = () => {
    Mixpanel.track(getEventName("customerLogout", "clicked", "logout"), {
        agentCode: getAgentCode(),
        user: getUserDetails()
    });
    clearAllCookies();
    if (isBtoCFlow()) {
        delete_cookie('agentCode', true);
        redirectToHome();
    } else {
        window.location.reload();
    }
}

export const filterSpaceSlashFromString = (string: string) => {
    if (string) return string.replace(/\s/g, '-').replace(/\//g, '-');
}

export const isFlowTypeProfile = () => {
    const { flowType } = getQueryParamsFromString(window.location.search);
    if (flowType === "profile") return true;
}

export const isFlowTypeCheckout = () => {
    const { flowType } = getQueryParamsFromString(window.location.search);
    if (flowType === "checkout") return true;
}

export const decryptBase64 = (encodedString: string | null) => {
    if (encodedString) {
        const value = encodedString.split('U2VjcmV0S3k=')[1];
        return atob(value);
    }
    else return null;
}

export const fetchGetScratchCard = (scratchCardConfig: any, localStorageName: string, localStorageValue: any) => {
    get(resolveURLParams(ENDPOINTS.GET_SCRATCH_CARD, scratchCardConfig, null), getDefaultHeaders(), true)
        .subscribe((response: AjaxResponse | AjaxError) => {
            window.localStorage.setItem(localStorageName, localStorageValue);
        }, (error: AjaxError) => {
        });
}

export const postSendSurvey = () => {
    post(ENDPOINTS.POST_SEND__SURVEY, null, getDefaultHeaders(), true)
        .subscribe((response: AjaxResponse | AjaxError) => {
        }, (error: AjaxError) => {
        });
}

export const isPWAinStandalone = () => {
    const nav: any = window.navigator;
    return (window.matchMedia('(display-mode: standalone)').matches) || (nav.standalone) || document.referrer.includes('android-app://');
}

export const formatCalculatorValues = (value: any) => value < 100000 ? Number(Number((value / 1000)).toFixed(2)) + 'K' :
    value < 10000000 ? Number(Number((value / 100000)).toFixed(2)) + 'L' : Number(Number((value / 10000000)).toFixed(2)) + 'Crs';

export const convertToINRabbreviations = (value: number) => {
    const addCommas = (value: number) => Math.ceil(value)?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
    return value < 100000 ? addCommas(value) :
        value < 10000000 ? Number(Number((value / 100000)).toFixed(2)) + ' Lakh' : Number(Number((value / 10000000)).toFixed(2)) + ' Crs'
};

export const isEven = (num: number) => {
    return num % 2 === 0
}

export const getQueryParamsFromEncryptedSearch = () => {
    const sharedByDpdetails = window.location.search;
    if (sharedByDpdetails) {
        try {
            return window.atob(sharedByDpdetails?.replace('?', ''));
        } catch (e) {
            return undefined;
        }
    }
}

export const capitalizeString = (stringToFormat: string) => {
    const words = stringToFormat.split(" ");
    const capitalizedWords = words.map((word) => {
        return word[0].toUpperCase() + word.substring(1);
    }).join(" ");
    return capitalizedWords;
}
export const scrollToElementId = (elementid: string) => {
    const elm: HTMLElement | null = document.getElementById(elementid);
    elm?.scrollIntoView();
};

export const goToMintPackDetails = (mintpack: any) => {
    redirectToOld(addAgentCode(`mint-pack-details?mintpackIds=${mintpack.encryptedMintPackId}`));
}

export const MFDetailsPageURL = (fund: any) => {
    return `/mutual-fund-detail/${filterSpaceSlashFromString(fund.schemeName)}-${filterSpaceSlashFromString(fund.category)}-${filterSpaceSlashFromString(fund.subCategory)}?schemeId=${fund?.schemeId}`;
}
export const MFDetailsPageURLWithEncryptedId = (fund: any) => {
    return `/mutual-fund-detail/${filterSpaceSlashFromString(fund.schemeName)}-${filterSpaceSlashFromString(fund.category)}-${filterSpaceSlashFromString(fund.subCategory)}?schemeId=${fund?.encryptedSchemeId}`;
}

export const redirectToMFDetailsPage = (fund: any) => {
    redirectToOld(MFDetailsPageURL(fund));
}

export const convertToLocalString = (text: any) => {
    if (text) {
        return text?.toLocaleString(navigator.language, { minimumFractionDigits: 2 });
    }
    return null
}

export const getFileServiceUrlFromFileId = (fileId: any) => {
    return SERVICE_TEMPLATE_FILE_URL + '/api/files/v1/download/' + fileId + '?broker=turtlemint&Caller=localhost&download=true&alias=';
};
export const exploreAllMintPacks = () => {
    redirectToOld(addAgentCode('mint-packs'));
}

export const gotoKnowMore = () => {
    redirectToOld(addAgentCode('know-more'));
}

export const redirectBasedOnBSE = (userInfo: any) => {
    if (window.location.href.includes("mf_share_stmt")) {
        window.location.pathname = "/v1/profile/portfolio"
    } 
    else if(userInfo?.user?.registeredWithBse === 3){
        window.location.reload();
    }
    else {
        window.location.href = '/v1/profile/kyc-details?flowType=checkout'
    }
}

export const urlToFile = (url: string, fileName: string) => {
    return fetch(url)
        .then(async (response: any) =>
            ({ blob: await response.blob(), fileType: response.headers.get('content-type') ?? 'image/png' }))
        .then(fileData => {
            var file = new File([fileData.blob], fileName, { type: fileData.fileType });
            return file;
        })
}
export const isRedirectFromMintpro = (urlParams: any)=> {
	return (
		((urlParams.has("source") && urlParams.get("source") == "mintpro") || urlParams.has("encryptedId"))
	);
};

export const getTaxStatus = (code: string)=>{
    return TAX_STATUS_OBJ[code] || 'NA';
}

export const returnTaxCode = (taxStatus: string)=>{
    return Object.keys(TAX_STATUS_OBJ).find((key) => {return TAX_STATUS_OBJ[key] === taxStatus});
}

export const downloadPdfFile = (url: string) => {
    if (isMintproApp()) {
        var featurePayload = {
            type: 'chromeTab',
            payload: {
                url: url
            },
        };
        window.postMessage(JSON.stringify(featurePayload), '*');
    } else {
        window.open(url, '_blank');
    }
}
export const isAgentEuin = ()=>{
    const euinsList = [
        "5f7b2268a9229200017d9d7e",
        "60b4c2fd42483b0001c21f19",
        "60d480f1c46ef50001d44ea7",
        "60781c59d8bb260001238396",
        "61939139ab4a3c0001800749",
        "61822b25dd064b0001fad601",
        "5dd673170b0a1f0a018d4ea2",
        "613390c486489b0001604abd",
        "5ff5dc0d24eb4f0001184755",
        "619f3e6cd8725700019549aa",
        "60754f47492f7300017eb052",
        "6152c4cbbf97060001cb1b7c",
        "60754fcb492f7300017eb0b2",
        "5e47d157d66d300001944bc0",
        "619f3d51e93d24000103f2d3",
        "620f97f88f1669000192a5a4",
        "6250030a363f00000125d363",
        "625674c0464dda0001e52d2f",
        "624d8042cc93500001e81c89",
        "632324171d1df500011c92da",
        "630472dc3ff74b0001accb6d",
        "636f6a4ab0ae45000146b607",
        "63aaae6c1a53a30001bba6eb",
        "62500399464dda0001e22ffd",
        "61a9f48495810a00013940e7",
        "64e312b230bc0a0001941233",
        "654206790ab8c90001cc6672",
        "654f1033eb9c2900014500bc",
        "656d912adc4fad0001c0c2ed",
        "64e30b90d501f400016798e7",
        "653365cd184e130001a61ceb",
        "65f182047880570001b60a54",
        "657ba51f4c208200010d04d7",
        "663ca6a33946a900018c0737",
      ];
    return euinsList.includes(getAgentCode() ?? "");
}

export const sortByProperty = (arr: any[], getProperty: (item: any) => string | undefined) => {
    return arr.sort((itemA, itemB) => {
        const valueA = getProperty(itemA) ?? ""; // Default to empty string
        const valueB = getProperty(itemB) ?? ""; // Default to empty string

        if (!valueA && valueB) return 1;  // Move null/undefined to the bottom
        if (!valueB && valueA) return -1; // Move non-null values up
        if (!valueA && !valueB) return 0; // Keep original order for both null

        return valueA.localeCompare(valueB); // Sort alphabetically
    });
};